module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Yezza":"Yezza","Sales":"Sales","Lead":"Lead","no_notification":"You have no notification"},"id":{"Yezza":"Yezza","Sales":"Jualan","Lead":"Lead","no_notification":"Tiada notifikasi"}}')
  delete Component.options._Ctor
}
